<template>

    <input class="block
            ring-0 focus:ring-blue border-gray-300
            placeholder-blue placeholder-opacity-80
            text-lg font-nexa text-blue
            rounded-md px-6 pt-5 pb-4"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
        autocomplete="false" />

</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props: ['modelValue'],

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
})
</script>
